import { addDays, differenceInCalendarDays, parseISO } from "date-fns";
import { IAppointmentDetails } from "../services/appointment-list/appointment-list.interface";
import { fromUnixToNormalDate } from "./unix-timestamp";

export function getLastNYears(n: number): number[] {
  return Array.from({ length: n }, (_, index) => new Date().getFullYear() - index);
}

export const capitalizeFirstLetterGeneric = (string: string | undefined) => {
  if (!string) return "";

  return string.charAt(0).toLocaleUpperCase() + string.substring(1);
};

export const getHospitalTimingArray = (schedule: string[]) => {
  return schedule.map((time) => {
    const details = time.split(":");

    return { day: details[0], time: details[1] };
  });
};


export const formatDoctorNames = (resources : any) => {
  if (!resources || resources.length === 0) return "";

  const resourceKeywordCheck = /(vet|tech|relief|veterinarian|stagger)/i;

  const doctorNames = resources
    .map((resource: { id: number; name: string | null }) => {
      return resource.name && !resourceKeywordCheck.test(resource.name) ? resource.name.split(",")[0] : null;
    },
    )
    .filter((name: string | null): name is string => name !== null && name !== "");

  if (doctorNames.length === 0) return "";

  if (doctorNames.length === 1) {
    return `Dr. ${doctorNames[0]}`;
  };

  const lastDoctor = doctorNames.pop();

  return `Dr. ${doctorNames.join(", Dr. ")} and Dr. ${lastDoctor}`;
};

// wellness renewal formatted pet names
export const formattedWellnessRenewalPetNames = (bookingPetsName: string[]) => {
  if (!Array.isArray(bookingPetsName) || bookingPetsName.length === 0) return "";

  const capitalize = (name: string) =>
    name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

  const capitalizedNames = bookingPetsName.map(capitalize);

  if (capitalizedNames.length === 1) {
    return `${capitalizedNames[0]}`;
  } else if (capitalizedNames.length === 2) {
    return `${capitalizedNames[0]} and ${capitalizedNames[1]}`;
  } else if (capitalizedNames.length === 3) {
    return `${capitalizedNames[0]}, ${capitalizedNames[1]} and ${capitalizedNames[2]}`;
  }

  return "";
};


// below function is used to get the some of the required
// event data in Customer Rating process

/* BELOW FUNCTION REVIEW APPOINTMENT DETAIL(pet appointment) as argument  */
export function getEventDataForCustomerRating(appointmentDetails: IAppointmentDetails | null) {
  if (!appointmentDetails) {
    return {
      petName: "",
      resources: [],
      month: "",
      day: "",
      time: "",
    };
  }

  const { start_at: appointmentDate, pet: { name: petName="" }={}, resources,
    location: { timeZone="" }={} } = appointmentDetails || {};

  const { time, month, day } = fromUnixToNormalDate(appointmentDate!, timeZone!);

  return {
    petName,
    resources,
    month,
    day,
    time,
  };
};

export const calculateDaysUntilExpiry = (endDateString?: string) => {
  if (!endDateString) {
    return { daysUntilExpiry: 0, isExpired: true };
  }

  // End date is the last covered day.
  const expiryDate = addDays(parseISO(endDateString), 1);
  const diffDays = differenceInCalendarDays(expiryDate, new Date());

  return {
    daysUntilExpiry: diffDays,
    isExpired: diffDays <= 0,
  };
};
